import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { forbidExtraProps } from 'airbnb-prop-types';

import { Navigate } from 'react-router';

import { connect } from 'react-redux';

import { productsCategories } from 'constants/products';

import { fetchUser } from 'dux/user/actions';
import { isFlagsDoneFetching } from 'dux/featureFlags/selectors';
import { getHasCompletedSkincareConsultation } from 'dux/user/selectors';

import { useCheckoutCategory } from './hooks/useCheckoutCategory';

const CheckoutRedirectHandler = ({ children, hasCompleteSkinProfile, flagsDonefetching }) => {
  const checkoutCategory = useCheckoutCategory();

  /**
   * We fetch the user here to cover multiple flows
   * 1) User accesses cart from URL
   * 2) User updates consultation, does not finish and accesses cart
   */
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  if (
    // If the checkout route doesn't exist
    !checkoutCategory ||
    // If skin profile incomplete
    (checkoutCategory === productsCategories.SKINCARE &&
      flagsDonefetching &&
      !hasCompleteSkinProfile)
    /**
     * For haircare flow, any incomplete hair profile
     * - can access cart page (/checkout/:category)
     * for old users who haven't replied to new questions (Supplements, Styling Gel).
     * The Algo formulates in best effort.
     * - can access the rest of the checkout flow (e.g. gift scenario).
     */
  ) {
    return <Navigate replace to="/account/reorder" />;
  }
  return children;
};

CheckoutRedirectHandler.propTypes = forbidExtraProps({
  children: PropTypes.node.isRequired,
  hasCompleteSkinProfile: PropTypes.bool.isRequired,
  flagsDonefetching: PropTypes.bool.isRequired,
});

export default connect(
  state => ({
    flagsDonefetching: isFlagsDoneFetching(state),
    hasCompleteSkinProfile: getHasCompletedSkincareConsultation(state),
  }),
  {}
)(CheckoutRedirectHandler);
